import { getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

export const orderCancellationRemark = [
	{value:'CANNOT BE TREATED', label:'CANNOT BE TREATED'},
	{value:'COURIER DELIVERY CHALLENGE', label:'COURIER DELIVERY CHALLENGE'},
	{value:'CUSTOMER NOT AVAILABLE TO ACCEPT', label:'CUSTOMER NOT AVAILABLE TO ACCEPT'},
	{value:'CUSTOMER NOT RESPONDING', label:'CUSTOMER NOT RESPONDING'},
	{value:'CUSTOMER NOT CONTACTABLE', label:'CUSTOMER NOT CONTACTABLE'},
	{value:'DISCOUNT CODE/PAYMENT MODE', label:'DISCOUNT CODE/PAYMENT MODE'},
	{value:'EXTRA MEDS', label:'EXTRA MEDS'},
	{value:'FINANCIAL ISSUE', label:'FINANCIAL ISSUE'},
	{value:'MANIFESTED NOT PICKED UP', label:'MANIFESTED NOT PICKED UP'},
	{value:'NO SCALPIE/FORM', label:'NO SCALPIE/FORM'},
	{value:'ORDER TO BE EDITED', label:'ORDER TO BE EDITED'},
	{value:'PLACED 2 ORDERS', label:'PLACED 2 ORDERS'},
	{value:'PIN CODE NOT SERVICEABLE', label:'PIN CODE NOT SERVICEABLE'},
	{value:'SPAM ORDER', label:'SPAM ORDER'},
	{value:'TEST ORDER', label:'TEST ORDER'},
	{value:'WRONG ORDER PLACED', label:'WRONG ORDER PLACED'},
]

export const statusOptions = [
	{ value: "1", label: "On Hold" },
	{ value: "2", label: "Open" },
	{ value: "3", label: "Pending" },
	{ value: "4", label: "Resolved" },
	{ value: "5", label: "Closed" },
];

export const statusOptionsTicketStats = [
	{ value: "On Hold", label: "On Hold" },
	{ value: "Open", label: "Open" },
	{ value: "Pending", label: "Pending" },
	{ value: "Resolved", label: "Resolved" },
	{ value: "Closed", label: "Closed" },
];

export const categoryMap = {
	order_related: "Order Related",
	medical_escalations: "Medical Escalations",
	customer_complaints: "Customer Complaints",
	payments: "Payments",
	tech_bugs: "Tech Bugs",
	international_prescription: "International Prescription",
	other_category: "Other",
	delivery_related: "Delivery Related",
	prescription_related: "Prescription Related",
	escalation: "Escalation",
	ivr_requests: "IVR Requests",
	delivery_Issues: "Delivery Issues",
	delivery_related_issues: "Delivery Related Issues"
};

export const subCategoryMap = {
	tech_bugs: 'Tech Issues',
	order_sync: 'Order Sync',
	app_issue: 'App issue ',
	edit_profile: 'Edit profile',
	login_issues_website: 'Login Issue on website',
	medical_escalations: 'Medical Escalations',
	follow_up_medical: 'Follow Up Intervention',
	follow_up_call: 'Follow Up Call',
	hairfall_issue: 'Hairfall',
	constipation_issue: 'Constipation',
	dandruff_issue: 'Dandruff',
	health_issue: 'Health conditions',
	itching_issue: 'Itching',
	product_reaction_issue: 'Product Reaction ',
	sexual_issue: 'Sexual issue',
	gastric_issue: 'Gastric issues',
	other_issue: 'Other Medical Issues',
	order_related: 'Order Related Concerns',
	order_cancellation: 'Order Cancellation',
	reverse_pick_up: 'Reverse Pick Up',
	damaged_product: 'Damaged Product',
	missing_product: 'Missing Product ',
	mismatch_product: 'Mismatch Product',
	delivery_Issues: 'Delivery Issues',
	reattempt_request: 'Reattempt Request',
	initiate_rto: 'Initiate RTO',
	tracking_link_Not_updated: 'Tracking Link Not Updated',
	wrong_tracking_status: 'Incorrect Tracking Status',
	amount_paid_no_order: 'Amount Paid Order Not Handed Over',
	payments: 'Payment Issue',
	payments_issue: 'Payment Issue',
	order_related_refunds: 'Order Related Refunds',
	payment_failure: 'Payment Failure No Order Placed',
	referral_code: 'Referall Code',
	customer_complaints: 'Customer Complaints',
	five_month_money_back: 'Five month money back',
	coach_service: 'Coach service',
	angry_customer: 'Angry Customer',
	no_results_traya: 'No Result with Traya',
	negative_review: 'Negative Review ',
	slot_missed: 'Slot Completely Missed',
	slot_not_catered: 'Slot not Catered On Time',
	customer_others: 'Other Customer Issue',
	traya_general_enquiries: 'General Queries',
	i_want_to_understand_more_about_the_treatment: 'Doctor Related Enquiries',
	doctor_related_enquiries: 'I Want To Understand More About The Treatment',
	hair_test: 'Hair Test',
	'how_does_the_hair_test_work?': 'How does the hair test work?',
	i_am_facing_difficulty_in_filling_the_hair_test: 'I am facing difficulty in filling the hair test',
	hair_coach: 'Hair Coach',
	hair_coach_general_enquiries: 'Hair coach general enquiries',
	i_have_a_problem_with_my_appointment: 'I Want To Report A Concern Regarding My Appointment',
	diet_plan: 'Diet Plan',
	"i_want_to_know_more_about_traya's_diet_plan": "I Want To Know More About Traya's Diet Plan",
	i_have_a_query_regarding_my_diet_plan: 'I have a query regarding my diet plan',
	reward_coins: 'Reward Coins',
	i_want_to_understand_more_about_rewards: 'I want to understand more about rewards',
	i_have_an_issue_with_my_reward_coins: 'I have an issue with my reward coins',
	prescription: 'Prescription',
	i_have_an_issue_with_my_prescription: 'I have an issue with my prescription',
	my_treatment_results: 'My Treatment/Results',
	i_have_concerns_with_my_results_after_using_traya: 'I Want To Discuss The Progress On My Treatment',
	'moneyback_guarantee_&_refund_policy': 'Moneyback Guarantee',
	moneyback_guarantee: 'Moneyback Guarantee',
	'payments_&_refunds': 'Payments & Refunds',
	i_want_to_know_about_payment_options: 'I Want To Know About Payment Options',
	i_have_a_refund_related_query: 'I Have A Refund Related Query',
	i_have_an_issue_with_my_payment: 'I Have An Issue With My Payment',
	how_to_use: 'How To Use',
	i_want_to_understand_usage_of_products_in_my_kit: 'I Want To Understand Usage Of Products In My Kit',
	other_queries_regarding_usage: 'Other Queries Regarding Usage',
	reorder_queries: "Next Month's Plan",
	i_have_a_query_regarding_reorder: 'I Have A Query Regarding Reorder',
	no_results_with_traya: 'No Results With Traya',
	return_request: 'Return Request',
	medical_document: 'Medical Document',
	referall_code: 'Referral Code',
	product_related_quality_issues: 'Product Related Quality Issues',
	hair_ras: 'Hair Ras',
	health_tatva: 'Health Tatva',
	scalp_oil_booster_oils: 'Scalp Oil / Booster Oils',
	gutt_shuddhi: 'Gutt Shuddhi',
	nasal_grit: 'Nasal Grit',
	digest_boost: 'Digest Boost',
	consti_clear: 'Consti Clear',
	cholest_vati: 'Cholest Vati',
	pcos_santulan: 'PCOS Santulan',
	thyro_santulan: 'Thyro Santulan',
	her_santulan: 'Her Santulan',
	mom_santulan: 'Mom Santulan',
	'minoxidil_2%': 'Minoxidil 2%',
	'minoxidil_5%': 'Minoxidil 5%',
	anti_dandruff_shampoo: 'Anti-Dandruff Shampoo',
	anti_dandruff_night_lotion: 'Anti-Dandruff Night Lotion',
	defence_shampoo: 'Defence Shampoo',
	recap_serum: 'Recap Serum',
	hair_vitamin: 'Hair Vitamin',
	cuticle_damage_range: 'Cuticle Damage Range',
	nourish_hair_oil_: 'Nourish Hair Oil ',
	new_product_suggestion: 'New Product Suggestion',
	swelling_issue: 'Swelling Issue',
	boils_issue: 'Boils Issue',
	'i_have_a_problem_with_my_existing_order(s)': 'I Have A Problem With My Existing Order(s)',
	auto_order_cancellation_initiated: 'Auto Order Cancellation Initiated',
	doctor_call: 'Doctor Call',
	case_deterioration: 'Case Deterioration',
	testing_subcate_prod: 'Testing Subcate Prod',
	auto_prepaid_rto: 'Return For Prepaid Order',
	return_for_prepaid_order: 'Return For Prepaid Order',
	test_subcat: 'Test Subcat',
	amount_paid_to_the_delivery_partner_but_order_not_delivered: 'Amount Paid To The Delivery Partner But Order Not Delivered',
	five_months_no_results: 'Five Months No Results',
	deterioration: 'Deterioration',
	non_alcohol_minoxidil_concerns: 'Non Alcohol Minoxidil Concerns',
	doctor_consultation_fee_refund: 'Doctor Consultation Fee Refund',
};

export const isComplaintTeam = () =>{
	const role = getCurrentUserRole();
  	const currentUserLevel = secureLocalStorage.getItem('level');
	const isLevel2Admin = role === ROLES_NAME.ADMIN && currentUserLevel === 2;
	const isSuperAdmin = role === ROLES_NAME.SUPER_ADMIN;
	return isSuperAdmin || isLevel2Admin;
}